import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

export default axios.create({
  baseURL: API_BASE_URL,
  mode: 'cors',
});
